import { USER_GROUP_REDUCER_KEYS as KEYS } from '../reducers/userGroupsReducerKeys'
import { createSelector } from 'reselect'

export const getUserGroupsMap = state => state.getIn([KEYS.REDUCER]).get(KEYS.BY_ID)
export const getUserGroups = createSelector(getUserGroupsMap, groups => groups.toList())
export const getOrderedUserGroups = createSelector(getUserGroups, groups => groups.sortBy(group => group.name))
